import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Button } from "../comp/ui/button";
import { Input } from "../comp/ui/input";
import { Textarea } from "../comp/ui/textarea";
import { Label } from "../comp/ui/label";
import { toast } from "sonner";
import { useState } from "react";
import { Header } from "../comp/Header";
import { CartItem, ShoppingCart } from "../comp/ShoppingCart";
import Cookies from "js-cookie";
import { catalogClient } from "../services/grpc";
import * as pb from '../generated/catalog_pb';
import { NewHeader } from '../comp/NewHeader'
import { Footer } from '../comp/Footer';

export function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [cartItemCount, setCartItemCount]= useState(0);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
const [isCartOpen, setIsCartOpen] = useState(false);
const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Message sent! We'll get back to you soon.");
    const req= new pb.MsqReq();
    req.setEmail(formData.email);
    req.setName(formData.name);
    req.setPhone(formData.phone);
    req.setTxt(formData.message);
   catalogClient.sendMsg(req, {}, (err, response) => {
      if (err) {
        console.error('Error fetching guid:', err.code, err.message);
      } else {
        toast.success("Ваше сообщение отправленно.");
      }
    });
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: ""
    });
  };
  const initializeApp = async () => {
  let isguid = Cookies.get('guid');
  if (typeof isguid != 'string') {
    const req= new pb.guidReq();  
   
    req.setIp(window.location.hostname);
    catalogClient.getGuid(req, {}, (err, response) => {
      if (err) {
        console.error('Error fetching guid:', err.code, err.message);
      } else {
        Cookies.set('guid', response.getGuid());
      }
    });
  }
  const guid = Cookies.get('guid');
 
  };
    const OnsetIsInCartStorage=(items:string[])=>{

  }
  const updateQuantity = (porodId: number, quantity: number,storage:string) => {
        try {
          if (quantity === 0) {
            removeFromCart(porodId,storage)
            return
          }
          const guid = Cookies.get('guid');
          if (typeof guid === 'string') {
            const req = new pb.CartAddReq();
            req.setGuid(guid);
            req.setProductId(porodId);
            req.setQty(quantity);
            req.setStorage(storage);
            catalogClient.cartUpdate(req, {}, (err, response) => {
              if (err) {
                console.error('Error adding to cart:', err.code, err.message);
              }
            });
          }
          setCartItems(prev => {
            const safeCartItems = prev || []
            return safeCartItems.map(item =>
              item.product.id === porodId && item.storage === storage ? { ...item, quantity,storage } : item
            )
          })
        } catch (error) {
          console.error('Error updating quantity:', error)
        }
      }
     
      const removeFromCart = (porodId: number,storage:string) => {
        try {
          const guid = Cookies.get('guid');
          if (typeof guid === 'string') {
          const req = new pb.CartRemoveReq();
          req.setGuid(guid);
          req.setProductId(porodId);
          req.setQty(0);
          req.setStorage(storage);
          catalogClient.cartRemove(req, {}, (err, response) => {
            
            if (err) {
              console.error('Error removing from cart:', err.code, err.message);
            }
          });
        }
          setCartItems(prev => {
            const safeCartItems = prev || []
            return safeCartItems.filter(item => !(item.product.id === porodId && item.storage === storage))
          })
        } catch (error) {
          console.error('Error removing from cart:', error)
        }
      }
      
        const setOrder = ()=>{
            if (!customerName || !customerPhone) {
              setAlertMessage(`Пожалуйста. Введите Ваше имя и номер телефона для связи`);
              return;
          }
        
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
              const req=new pb.OrderAcceptReq();
              req.setGuid(guid);
              req.setName(customerName);
              req.setPhone(customerPhone);
              catalogClient.orderAccept(req, {}, (err, response) => {
                if (err) {
                  console.error('Error removing from cart:', err.code, err.message);
                } else {
                if (response.getStatus()=="fail") { 
                  setAlertMessage(`${response.getMessage()}`);
                } else {
                  setAlertMessage(`Спасибо за заказ.\n\ 
                    В ближайшее время наш менеджер свяжется с Вами.\n\ 
                    Номер вашего заказа: ${response.getNum()}`);
                  setCartItems([]);
                  setIsCartOpen(false);
                }
                  return;
                }
              });
            }
          }
      
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <NewHeader
           cartItemCount={cartItemCount}
           onCartClick={() => setIsCartOpen(true)}
           onAccountClick={() => setIsAccountOpen(true)}
           searchQuery={searchQuery}
           onSearchChange={setSearchQuery}
           page='contact'
         />

      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <div className="text-center mb-16 mt-10">
          <h1 className="text-5xl font-bold text-blue-900 mb-4">Контакты</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-blue-900 mb-6">Связаться с нами:</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="name">Ваше имя:*</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  placeholder=""
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="email">Email: *</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john@example.com"
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="phone">Телефон</Label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(555) 123-4567"
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="subject">Тема:*</Label>
                <Input
                  id="subject"
                  name="subject"
                  type="text"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder=""
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="message">Сообщение: *</Label>
                <Textarea
                  id="message"
                  name="message"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  placeholder=""
                  rows={6}
                  className="mt-1"
                />
              </div>

              <Button 
                type="submit" 
                className="w-full bg-blue-600 hover:bg-blue-700"
              >
                Отравить
              </Button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-6">Как нас найти</h2>
              
              <div className="space-y-6">
                {/* Address */}
                <div className="flex gap-4">
                  <div className="bg-blue-100 rounded-full p-3 h-fit">
                    <MapPin className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-blue-900 mb-1">Адрес</h3>
                    <p className="text-gray-600">
                      Санкт-Петербург<br/>
                      Предпортовая ул., 8Т,<br/> 
                      склад № 17
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex gap-4">
                  <div className="bg-blue-100 rounded-full p-3 h-fit">
                    <Phone className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-blue-900 mb-1">Телефон</h3>
                    <p className="text-gray-600">
                        +7 (981) 965-68-88<br />
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex gap-4">
                  <div className="bg-blue-100 rounded-full p-3 h-fit">
                    <Mail className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-blue-900 mb-1">Email</h3>
                    <p className="text-gray-600">
                      Evroazia_sale@mail.ru<br />
                    </p>
                  </div>
                </div>

                {/* Hours */}
                <div className="flex gap-4">
                  <div className="bg-blue-100 rounded-full p-3 h-fit">
                    <Clock className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-blue-900 mb-1">Часы работы</h3>
                    <p className="text-gray-600">
                      Пн - Пт: 09:00 - 18:00<br />
                      Суббота: Выходной<br />
                      Воскресенье: Выходной
                    </p>
                  </div>
                </div>
              </div>
            </div>

     
          </div>
        </div>
 
      <iframe src="https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=23614169771" width="100%" height="400"  frameBorder="0"></iframe>  

      </div>
       <Footer/>
       {Array.isArray(cartItems) && (
                    <ShoppingCart
                      isOpen={isCartOpen}
                      onOpenChange={setIsCartOpen}
                      cartItems={cartItems}
                      onUpdateQuantity={updateQuantity}
                      onRemoveItem={removeFromCart}
                      onOrder={setOrder}
                      customerName={customerName}
                      customerPhone={customerPhone}
                      setCustomerName={setCustomerName}
                      setCustomerPhone={setCustomerPhone}
                      setCartItemCount={setCartItemCount}
                      setIsInCartStorage={OnsetIsInCartStorage}
                    />
                  )}
    </div>
  );
}
